import React, { useEffect, useMemo, useState } from "react";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

import axios from "axios";

import "./style.scss";

const MILLISINADAY = 86400000;

const Calendar = ({
  setDataParaAgendar,
  diasDisponiveis,
  largura,
  altura,
  setShowCalendario,
  data,
  setDataAlterada,
  gerarBoleto,
  haParcelaVencida,
  parcelaUnicaVencendoNoMes,
  parcelasSelecionadas,
  mensagemCalendario,
  disabledDayOnClick,
}) => {
  const [feriados, setFeriados] = useState(null);

  let url = window.location.href.toString();

  const FINANCEIRO = url.includes("financeiro") ? true : false;

  useEffect(() => {
    if (feriados) {
      setDat();
      renderCalendar(disabledDayOnClick);
    }
  }, [feriados]);

  useEffect(() => {
    renderCalendar(disabledDayOnClick);
  }, [disabledDayOnClick]);

  // useEffect(() => {
  //   renderCalendar();
  // }, [feriados]);

  const dataParcelaUnicaVencendoNoMes = parcelaUnicaVencendoNoMes
    ? parcelasSelecionadas?.[0].parcela.dataVencimento
    : "";

  const fetchFeriados = `https://brasilapi.com.br/api/feriados/v1/${new Date().getFullYear()}`;

  useEffect(() => {
    let temp = "";

    const loadFeriados = async () => {
      temp = await axios.get(fetchFeriados);

      setFeriados(temp.data);
    };

    loadFeriados();
  }, []);

  let diaDaSemana = new Date().getDay();

  const returnDateIfWeekend = () => {
    if (diaDaSemana === 6)
      return new Date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 2
        )
      );
    else if (diaDaSemana === 0)
      return new Date(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        )
      );
    else return new Date();
  };

  const date = useMemo(() => {
    if (FINANCEIRO) {
      setDataParaAgendar(formataData());
      return returnDateIfWeekend();
    } else {
      return new Date();
    }
  }, [FINANCEIRO]);

  function formataData() {
    let dateSet = "";

    dateSet = returnDateIfWeekend();

    return (
      dateSet.getFullYear() +
      "-" +
      (dateSet.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dateSet.getDate() +
      "T00:00:00"
    );
  }

  // para abrir o calendário no mês do primeiro dia disponível

  function setDat() {
    if (FINANCEIRO) {
      data =
        date?.getFullYear() +
        "-" +
        (date?.getMonth() + 1 < 10
          ? "0" + (date?.getMonth() + 1)
          : date?.getMonth() + 1) +
        "-" +
        (date?.getDate() < 10 ? "0" + date?.getDate() : date?.getDate());
    } else {
      if (data != "") {
        date?.setDate(data?.split("/")[0]);
        date?.setMonth(data?.split("/")[1] - 1);
        date?.setFullYear(data?.split("/")[2]);
      } else {
        date?.setDate(diasDisponiveis[0]?.split("-")[2]);
        date?.setMonth(diasDisponiveis[0]?.split("-")[1] - 1);
        date?.setFullYear(diasDisponiveis[0]?.split("-")[0]);
      }
    }
    date?.setDate(1);
  }

  function removeDiaSelecionado() {
    let itensCalendario = Array.from(
      document.getElementsByClassName("diaSelecionado")
    );
    itensCalendario.forEach((item) => {
      item.classList.remove("diaSelecionado");
    });
  }

  const disabledDay = (i, day, date) => {
    return `<div class="diaDoMes inativo"><span class="centralized diadomes"
          name=${i < 10 ? "0" + i : i}/${
      date.getMonth() + 1
    }/${date.getFullYear()} data=${day}
          >${i < 10 ? "0" + i : i}</span></div>`;
  };

  // flag diaSelecionado para quando o dia é o dia selecionado e adiciona a classe do dia selecionado
  const enabledDay = (i, day, date, diaSelecionado, disabled) => {
    return `<div
    class="diaDoMes semDiaDisponivel diadisponivelagendamento 
    diaDisponivelAgendamentoBoleto 
    ${diaSelecionado ? "diaSelecionado" : ""}
    ${disabled ? "disabledDay" : ""}">
    <span class="centralized diadomes"
    name=${i < 10 ? "0" + i : i}/${
      date.getMonth() + 1
    }/${date.getFullYear()} data=${day}
    >${i < 10 ? "0" + i : i}</span></div>`;
  };

  const renderCalendar = (disabled) => {
    window.onclick = function (event) {
      if (
        !event.target.matches(".diaDoMes") &&
        !event.target.matches(".inativo") &&
        !event.target.matches(".days") &&
        !event.target.matches(".prev") &&
        !event.target.matches(".next") &&
        !event.target.matches(".agendamento") &&
        !event.target.matches(".semDiaDisponivel") &&
        !event.target.matches(".monthSelector") &&
        !event.target.matches(".MuiSvgIcon-root") &&
        !event.target.matches(".diadomes") &&
        !event.target.matches("path") &&
        !event.target.matches("calendar") &&
        !event.target.matches("month") &&
        !event.target.matches(".agendamentoSolicitacao__agendar__data") &&
        !event.target.matches(
          ".agendamentoSolicitacao__agendar__data__title"
        ) &&
        !event.target.matches(".closeCalendario") &&
        !event.target.matches(
          ".agendamentoSolicitacao__agendar__data__placeholder"
        )
      ) {
        setShowCalendario(false);
      }
    };

    // pega o primeiro dia do mês
    const monthDays = document.querySelector(".days");

    // pega o último dia do mês corrente
    const lastDay = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDate();
    // pega o último dia do mês passado
    const prevLastDay = new Date(
      date.getFullYear(),
      date.getMonth(),
      0
    ).getDate();

    // pega o dia da semana que o mês corrente inicia (0 == domingo, 1 == segunda até 6 == sábado)
    const firstDayIndex = date.getDay();

    // pega o dia da semana que o mês corrente finaliza (0 == domingo, 1 == segunda até 6 == sábado)
    const lastDayIndex = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0
    ).getDay();

    const nextDays = 7 - lastDayIndex - 1;

    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    document.querySelector(".date h1").innerHTML =
      months[date.getMonth()] + " - " + date.getFullYear();

    let days = "";

    for (let x = firstDayIndex; x > 0; x--) {
      days += `<div class="prev-date">${prevLastDay - x + 1}</div>`;
    }

    // montagem dos dia no calendário
    for (let i = 1; i <= lastDay; i++) {
      let diaDisponivel = false;

      // monta string para fazer a comparação com o array de agentes disponíveis
      let day =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        "-" +
        (i < 10 ? "0" + i : i);

      if (FINANCEIRO) {
        let today = new Date();

        let tempDate = new Date(day);

        const YESTERDAY_MILLIS = today.getTime() - MILLISINADAY;

        // if seguinte para verificação se o dia é feriado ou se é fim de semana, dias que não podem ser selecionados para gerar boleto

        if (
          feriados?.findIndex((feriado) => feriado.date == day) != -1 ||
          new Date(day).getDay() === 5 ||
          new Date(day).getDay() === 6
        ) {
          days += disabledDay(i, day, date);
        } else if (haParcelaVencida) {
          // se tiver parcela vencida, só poderá selecionar o dia atual e os dois próximos
          // se sexta-feira -> pode selecionar sexta, segunda e terça
          // se sábado ou domingo -> pode selecionar segunda, terça ou quarta
          let verificaDia = new Date().getDay();

          if (day === data?.split("T")[0]) {
            days += enabledDay(i, day, date, "diaSelecionado", disabled);
          }
          // case de sexta feira
          else if (verificaDia === 5) {
            if (
              tempDate.getTime() > YESTERDAY_MILLIS &&
              tempDate.getTime() < today.getTime() + MILLISINADAY * 4
            ) {
              days += enabledDay(i, day, date, false, disabled);
            } else {
              days += disabledDay(i, day, date);
            }
          }
          // case hoje seja sábado -> pode selecionar segunda,terça ou quarta,
          // daí que conta o today.getTime() + 345600000 (milissegundos em 4 dias)
          else if (verificaDia === 6) {
            if (
              tempDate.getTime() > YESTERDAY_MILLIS &&
              tempDate.getTime() < today.getTime() + MILLISINADAY * 4
            ) {
              days += enabledDay(i, day, date, false, disabled);
            } else {
              days += disabledDay(i, day, date);
            }
          }
          // caso hoje seja domingo -> pode selecionar segunda,terça ou quarta,
          // daí que conta o today.getTime() + 259200000 (milissegundos em 3 dias)
          else if (verificaDia === 0) {
            if (
              tempDate.getTime() > YESTERDAY_MILLIS &&
              tempDate.getTime() < today.getTime() + MILLISINADAY * 3
            ) {
              days += enabledDay(i, day, date, false, disabled);
            } else {
              days += disabledDay(i, day, date);
            }
          } else {
            if (
              tempDate.getTime() > YESTERDAY_MILLIS &&
              tempDate.getTime() < today.getTime() + MILLISINADAY * 2
            ) {
              days += enabledDay(i, day, date, false, disabled);
            } else {
              days += disabledDay(i, day, date);
            }
          }
        } else {
          // if para deixar selecionado somente o dia de vencimento da parcela única que está vencendo no mês corrente
          if (
            parcelaUnicaVencendoNoMes &&
            day === dataParcelaUnicaVencendoNoMes.split("T")[0]
          ) {
            days += enabledDay(i, day, date, "diaSelecionado", disabled);
          } else if (
            (!parcelaUnicaVencendoNoMes && day == data) ||
            (!parcelaUnicaVencendoNoMes && day == data.split("T")[0])
          ) {
            days += enabledDay(i, day, date, "diaSelecionado", disabled);
          }
          // if para deixar selecionar somente os dias disponíveis: se houver parcela vencida só pode selecionar o dia atual e
          // os próximos 2, se não pode selecionar dentre 30 dias corridos
          else if (
            !parcelaUnicaVencendoNoMes &&
            tempDate.getTime() > YESTERDAY_MILLIS &&
            tempDate.getTime() < today.getTime() + 2592000000
          ) {
            days += enabledDay(i, day, date, false, disabled);
          }
          // fallback para dias que não podem ser selecionados
          else {
            days += disabledDay(i, day, date);
          }
        }
      } else {
        // função que seleciona todos os dias disponíveis para agendamento
        // só irão receber a classe agendamento os dias que há algum 'interval' disponível
        for (let j = 0; j < diasDisponiveis.length; j++) {
          if (day == data?.split("/").reverse().join("-")) {
            diaDisponivel = true;
            days += `<div class="diaDoMes agendamento diaSelecionado">
          <span class="centralized diadomes"
          name=${i < 10 ? "0" + i : i}/${
              date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1
            }/${date.getFullYear()}  data=${day}
          >${i < 10 ? "0" + i : i}</span></div>`;

            break;
          } else if (
            day == diasDisponiveis[j].toString() &&
            diasDisponiveis[j].length > 0
          ) {
            diaDisponivel = true;
            days += `<div class="diaDoMes agendamento">
          <span class="centralized diadomes"
          name=${i < 10 ? "0" + i : i}/${
              date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1
            }/${date.getFullYear()}  data=${day}
          >${i < 10 ? "0" + i : i}</span></div>`;
            break;
          }
        }

        // carrega o dia que não tiver agendamento disponível
        if (diaDisponivel == false) {
          if (new Date(day).getTime() <= new Date().getTime()) {
            days += `<div class="diaDoMes inativo"><span class="centralized diadomes"
          name=${i < 10 ? "0" + i : i}/${
              date.getMonth() + 1
            }/${date.getFullYear()} data=${day}
          >${i < 10 ? "0" + i : i}</span></div>`;
          } else {
            days += `<div class="diaDoMes semDiaDisponivel"><span class="centralized diadomes"
          name=${i < 10 ? "0" + i : i}/${
              date.getMonth() + 1
            }/${date.getFullYear()} data=${day}
          >${i < 10 ? "0" + i : i}</span></div>`;
          }
        }
      }
    }

    if (FINANCEIRO) {
      // carrega os dias do mês seguinte
      let hoje = new Date();
      for (let k = 1; k <= nextDays; k++) {
        // monta string para fazer a comparação com o array de agentes disponíveis
        let day =
          date.getFullYear() +
          "-" +
          (date.getMonth() + 2 < 10
            ? "0" + (date.getMonth() + 2)
            : date.getMonth() + 2) +
          "-" +
          (k < 10 ? "0" + k : k);

        let tempDate = new Date(day);

        if (
          tempDate.getTime() <
          hoje.getTime() + (haParcelaVencida ? 172800000 : 2592000000)
        ) {
          days += `<div class="next-date nextdisponivel">${k}</div>`;
        } else {
          days += `<div class="next-date">${k}</div>`;
        }
      }
    } else {
      // carrega os dias do mês seguinte
      for (let k = 1; k <= nextDays; k++) {
        days += `<div class="next-date">${k}</div>`;
      }
    }

    // monta o calendário
    monthDays.innerHTML = days;
    if (!FINANCEIRO) {
      // pega exatamente os dias do mês
      let dias = Array.from(document.getElementsByClassName("agendamento"));

      dias.forEach((item) => {
        item.addEventListener("click", (event) => {
          // pega o dia selecionado
          setDataParaAgendar(event.target.attributes[1].value);
          setShowCalendario(false);
          item.classList.add("diaSelecionado");
        });
      });
    }
    if (FINANCEIRO) {
      // pega exatamente os dias do mês
      addClick();
    }
  };

  function addClick() {
    let dias = Array.from(
      document.getElementsByClassName("diadisponivelagendamento")
    );

    dias.forEach((item) => {
      item.addEventListener("click", (event) => {
        if (event?.target?.attributes[2]?.value) {
          removeDiaSelecionado();
          // pega o dia selecionado
          setDataParaAgendar(event.target.attributes[2].value);
          setShowCalendario(false);
          item.classList.add("diaSelecionado");
          setDataAlterada(event.target.attributes[2].value);
        }
      });
    });
  }

  // if (!feriados) return "";

  const buttonDisabledStyle = disabledDayOnClick
    ? {
        color: "#4d4d4d",
        opacity: 0.5,
        fontSize: "24px",
      }
    : {
        fill: "#003DA5",
        fontSize: "24px",
      };

  return (
    <div
      className="calendar"
      style={{
        width: largura,
        height: altura,
      }}
    >
      <div className="month">
        <div className="date">
          <h1></h1>
        </div>
        <div className="monthSelector">
          <button
            className="prev"
            onClick={() => {
              date.setMonth(date.getMonth() - 1);

              renderCalendar(disabledDayOnClick);
            }}
            disabled={disabledDayOnClick}
          >
            <ArrowLeftIcon style={buttonDisabledStyle} />
          </button>
          <button
            className="next"
            onClick={() => {
              date.setMonth(date.getMonth() + 1);
              renderCalendar(disabledDayOnClick);
            }}
            disabled={disabledDayOnClick}
          >
            <ArrowRightIcon style={buttonDisabledStyle} />
          </button>
        </div>
      </div>
      <div className="weekdays">
        <div>Dom</div>
        <div>Seg</div>
        <div>Ter</div>
        <div>Qua</div>
        <div>Qui</div>
        <div>Sex</div>
        <div>Sab</div>
      </div>
      <div className="days"></div>
      {!gerarBoleto && (
        <div className="disponivel centralized-space-evenly">
          <span>Dia disponível</span>
          <span>Dia selecionado</span>
        </div>
      )}
      {FINANCEIRO && (
        <p
          style={{
            fontSize: "12px",
            marginTop: "16px",
            marginBottom: "0",
            borderTop: "2px solid #d1d1d1",
            paddingTop: "16px",
          }}
        >
          {mensagemCalendario()}
        </p>
      )}
      {gerarBoleto && (
        <div className="centralized-flex-start">
          <span className="dataGerarBoleto">Datas disponíveis</span>
        </div>
      )}
    </div>
  );
};

export default Calendar;
